import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UsersIDRequestModel } from "../models/UserModels/UsersIDRequestModel";
import { DepartmentModel } from "../models/DepartmentModels/DepartmentModel";
import { DepartmentUsersIDRequestModel } from "../models/DepartmentModels/DepartmentUsersIDRequestModel";
import { RequestHandlerService ,RequestOptionsModel} from "bnsights-utilities-library";



@Injectable({
  providedIn: 'root'
})
export class DepartmentService {
  ApiUrl = "/api/admin/Department/";
  deletedID: string="";
  constructor(private http: RequestHandlerService) {
  }


  addDepartment( AddModel: DepartmentModel) { 
    return this.http.post(this.ApiUrl + 'AddDepartment', AddModel);
  }
  getEditDepartment(id: string) {
    let params = new HttpParams();
    params = params.append("id", id);
    return this.http.get(this.ApiUrl + 'EditDeparment', params);

  }
  editDepartment( EditModel: DepartmentModel) {
    return this.http.post( this.ApiUrl + 'EditDeparment', EditModel);
  }
  setDeletedId(id: string) {
    this.deletedID = id;
  }
  deleteDepartment(id:string) {
    //let params = new HttpParams();
    //params = params.append("id", id);
    let body = new HttpParams();
    body = body.append("id", id);
    console.log("passed id in service:");
    console.log(JSON.stringify(id));
    return this.http.post(this.ApiUrl + 'DeleteDeparment', JSON.stringify(id));
  }
  
  addUsersToDepartment( AddModel: DepartmentUsersIDRequestModel) {
   
    return this.http.post( this.ApiUrl + 'AddUsersToDepartment', AddModel);
  }


  deleteUserFromDepartment( userID:string,DepartmentId:string) {
  
    let params = new HttpParams();
    params = params.append("userID",userID);
    params = params.append("DepartmentId",DepartmentId);

    return this.http.post(this.ApiUrl + 'DeleteUserFromDepartment', null,params);
  }
  getDepartmentInfo(DepartmentId:string) {

    let params = new HttpParams();
    params = params.append("departmentId",DepartmentId);
    return this.http.post(this.ApiUrl + 'GetDepartmentInfo', null, params);
  }
  
  
  
}
